import React from "react";

import { DespatchSectionsProps } from "../types";
import { DespatchAddressesSection } from "./components/AddressSection";
import { DespatchStatusSection } from "./components/StatusSection";
import { DespatchTimeSection } from "./components/TimeSection";
import { Container } from "./styles";

interface DespatchDetailsTabProps extends DespatchSectionsProps {}

export const DespatchesDetails = ({ ...baseSectionProps }: DespatchDetailsTabProps) => {
  return (
    <Container data-cy="despatch-details-maintenance">
      <DespatchStatusSection {...baseSectionProps} />
      <DespatchTimeSection />
      <DespatchAddressesSection />
    </Container>
  );
};
